import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of, mergeMap, tap, lastValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '@uw-env/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private authService: AuthService, private router: Router, private translateService: TranslateService
  ){
   }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let obs$;

      if ((route.queryParams && route.queryParams.access)) {

        // store the access token received as query param in localstorage
        // in order to provide value for authorization header for refresh-token api


        obs$ = this.authService.refreshToken(null).pipe(
          tap((token: any) => localStorage.setItem('token', token)),
          mergeMap((_) => this.authService.loadProfileWithPermission())
        );
      } else if (localStorage.getItem('token')) {
        // verify token
        obs$ = this.authService.refreshToken(localStorage.getItem('token')!).pipe(
          mergeMap((_) => this.authService.loadProfileWithPermission())
        );
      }

      if (route.queryParams && route.queryParams.lang && !localStorage.getItem('langToggleUsed')) {
        localStorage.setItem('lang', ['en', 'fr'].includes(route.queryParams.lang) ? route.queryParams.lang: 'en');
        this.translateService.use(route.queryParams.lang);
      }

      let isSSOUser = localStorage.getItem('isSSOUser');

      if (obs$) {
        return lastValueFrom(obs$).then(
          (_ : any) => {
            // this.router.navigate(['/private']);
            return true;
          }
        ).catch((error: any) => {
          localStorage.clear();
          window.location.href = `${environment.donorSiteUrl}?refreshTokenFailed=true&isSSOUser=${isSSOUser}`;
          return false;
        });
      } else {
        window.location.href = `${environment.donorSiteUrl}?refreshTokenFailed=true&isSSOUser=${isSSOUser}`;
        return of(false);
      };

      // return queryParams.access || this.authService.getUser();


      //  if ( this.authService.getUser()) {
      //    return true;
      //  }
      //  this.route.navigate(['error']);
      // return false;
  }

}
